export default __webpack_public_path__ + "assets/webgl/complete-20.90991d33.jpg";